import { storeToRefs } from 'pinia';
import { extraGuaranteeSidebarStore } from '~/stores/extraGuaranteeSidebar';

export default function () {

  const store = extraGuaranteeSidebarStore();
  const { isExtraGuaranteeOpen } = storeToRefs(store);

  return {
    ...store,
    isExtraGuaranteeOpen,
  };

}